var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.invoiceItem.id}}),(
            _vm.invoiceItem.item.type == _vm.LAB_TYPE &&
            _vm.isNewLabProfile &&
            _vm.invoiceItem.record_id
        )?_c('router-link',{attrs:{"to":{
            name: 'lab',
            params: {
                id: _vm.invoiceItem.record_id,
                patientName: _vm.invoiceItem.patient.name,
                patientId: _vm.invoiceItem.patient.encoded_id
            }
        }}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):(
            _vm.invoiceItem.item.type == _vm.LAB_TYPE &&
            _vm.invoiceItem.soap &&
            _vm.invoiceItem.soap.id &&
            !_vm.isNewLabProfile
        )?_c('a',{attrs:{"href":_vm.getSoapLabLink()},domProps:{"innerHTML":_vm._s(_vm.name)}}):(
            _vm.invoiceItem.item.type == _vm.LAB_TYPE &&
            this.invoiceItem.record != null &&
            !_vm.isNewLabProfile
        )?_c('a',{attrs:{"href":_vm.getPatientLabLink()},domProps:{"innerHTML":_vm._s(_vm.name)}}):(
            _vm.invoiceItem.record &&
            _vm.invoiceItem.business_id == _vm._setting.business_id &&
            _vm._hasAccess('patient.record.update')
        )?_c('b',{staticClass:"text-primary",class:_vm.disabled ? 'disabled cursor-not-allowed' : 'cursor-pointer',on:{"click":_vm.editRecord}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):(_vm.invoiceItem.record)?_c('b',{staticClass:"text-primary cursor-pointer",on:{"click":_vm.viewRecord}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }